export default function tabSection() {
    document.querySelectorAll('.r-tab-container').forEach((tabGroup) => {
        const tabLabels = Array.from(tabGroup.querySelectorAll('.r-tab-label'));
        const tabContents = Array.from(tabGroup.querySelectorAll('.r-tab'));
        let currentIndex = tabLabels.findIndex((label) => label.classList.contains('active'));

        // --- Create dots ---
        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'r-tab-dots';

        tabLabels.forEach((_, i) => {
            const dot = document.createElement('div');
            dot.className = 'r-tab-dot';
            if (i === currentIndex) dot.classList.add('active');
            dot.addEventListener('click', () => activateTab(i));
            dotsContainer.appendChild(dot);
        });

        tabGroup.appendChild(dotsContainer);

        function activateTab(index) {
            tabLabels.forEach((label, i) => {
                label.classList.toggle('active', i === index);
                label.style.display = window.innerWidth < 768 ? (i === index ? 'inline-block' : 'none') : 'inline-block';
            });
            tabContents.forEach((content, i) => {
                content.classList.toggle('active', i === index);
            });
            tabGroup.querySelectorAll('.r-tab-dot').forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });
            currentIndex = index;
        }

        function updateVisibility() {
            if (window.innerWidth < 768) {
                dotsContainer.style.display = 'flex';
                activateTab(currentIndex);
            } else {
                dotsContainer.style.display = 'none';
                tabLabels.forEach((label) => label.style.display = 'inline-block');
            }
        }

        // --- Swipe gesture support ---
        let startX = 0;
        let endX = 0;

        const swipeZone = tabGroup;

        swipeZone.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });

        swipeZone.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].clientX;
            handleSwipe();
        });

        swipeZone.addEventListener('mousedown', (e) => {
            startX = e.clientX;
        });

        swipeZone.addEventListener('mouseup', (e) => {
            endX = e.clientX;
            handleSwipe();
        });

        function handleSwipe() {
            const diff = endX - startX;
            if (Math.abs(diff) > 30 && window.innerWidth < 768) {
                if (diff > 0) {
                    // swipe right
                    currentIndex = (currentIndex - 1 + tabLabels.length) % tabLabels.length;
                } else {
                    // swipe left
                    currentIndex = (currentIndex + 1) % tabLabels.length;
                }
                activateTab(currentIndex);
            }
        }

        window.addEventListener('resize', updateVisibility);
        updateVisibility();

        // Manual tab click
        tabLabels.forEach((label, index) => {
            label.addEventListener('click', () => activateTab(index));
        });

        // Initial activation
        activateTab(currentIndex === -1 ? 0 : currentIndex);
    });
}
